import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { DataService } from "src/app/shared/Services/data.service";
import { HttpClient } from "@angular/common/http";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import pdfMake from "pdfmake/build/pdfMake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import * as moment from "moment";
import * as momenttz from "moment-timezone";
import { ToastrService } from "ngx-toastr";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
@Component({
  selector: "app-machine-report",
  templateUrl: "./machine-report.component.html",
  styleUrls: ["./machine-report.component.scss"],
})
export class MachineReportComponent implements OnInit {
    private destroy$: Subject<void> = new Subject<void>();
    private cancelPreviousRequests$ = new Subject<void>();
  timezone: any;
  custId;
  maxdate: any;
  mindate: any;
  action: any;
  toDate;
  fromDate: any;
  currentPage = 1;
  itemsPerPage = 5;
  pageSize;
  tableData: any = [];
  userDetails: any;
  selectedDepartment: any;
  exportViaMail: boolean = false;
  departmentData: any = [];
  showTable: boolean = false;
  breadCrumbItems: Array<{}>;
  pdfBool: boolean = false;
  csvBool: boolean = false;
  mailform: FormGroup;
  base64String;
  custName: any;

  deviceList: any = [];
  deviceListData: any = [];
  deviceId: any;
  deviceName: any;
  isData = true;
  tableDayData: any = [];

  hasBreakdown: boolean = false;
  hasInterlock: boolean = false;
  hasPin2: boolean = false;
  hasAnalog1: boolean = false;
  hasAnalog2: boolean = false;

  constructor(
    public formBuilder: FormBuilder,
    private dataservice: DataService,
    private http: HttpClient,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) {
    this.userDetails = JSON.parse(sessionStorage.getItem("currentUser"));
    this.custId = this.userDetails["user"]["custId"];
    const today = new Date();
    this.custName = this.userDetails["user"]["name"];

    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const yesterday1 = new Date(today);
    yesterday1.setDate(yesterday1.getDate() - 1);

    const oneYearBack = new Date();
    oneYearBack.setFullYear(today.getFullYear() - 1);

    const yyyy = oneYearBack.getFullYear();
    const mm = String(oneYearBack.getMonth() + 1).padStart(2, "0");
    const dd = String(oneYearBack.getDate()).padStart(2, "0");

    this.mindate = `${yyyy}-${mm}-${dd}`;

    const yyyyMax = today.getFullYear();
    const mmMax = String(today.getMonth() + 1).padStart(2, "0");
    const ddMax = String(today.getDate()).padStart(2, "0");

    this.maxdate = `${yyyyMax}-${mmMax}-${ddMax}`;
    this.maxdate = yesterday.toISOString().split("T")[0];
    this.fromDate = yesterday1.toISOString().split("T")[0];
    this.toDate = yesterday.toISOString().split("T")[0];
  }

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "K2" },
      { label: "Machine Reports", active: true },
    ];
    this.getDepartment();
    this.mailform = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
    });
    this.convertImageToBase64();
    this.auditLogs();
  }

  auditLogs() {
    let obj = {
      custID: this.custId,
    };

    this.dataservice
      .reportApi("auditlog/machinereport", obj)
      .subscribe(
        (res) => {},
        (error) => {
          this.toastr.error("Server Unreachable", error);
        }
      );
  }

  department = [];
  selectedDepartmentId: any;

  getDepartment() {
    this.department = [];
    this.departmentData = [];
    this.dataservice
      .get(`department?custId=${this.custId}`)
      .subscribe((res: any) => {
        if (res && res["data"]?.length) {
          this.department = res["data"];
          this.departmentData = [
            { departmentName: "All Department", departmentId: "All Department" },
            ...this.department,
          ];
          this.selectedDepartment = this.departmentData[0]["departmentName"];
          this.selectedDepartmentId = this.departmentData[0]["departmentId"];
          this.getDevices();
        }
      });
  }

  convertImageToBase64() {
    const imagePath = "assets/wimera/Wimera_Logo_wSlogan_Green.png";
    this.http.get(imagePath, { responseType: "blob" }).subscribe(
      (data: Blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.base64String = reader.result as string;
        };
        reader.readAsDataURL(data);
      },
      (error) => {
        console.error("Error loading the image:", error);
      }
    );
  }

  getDevices() {
    this.dataservice.get("api/device").subscribe((res) => {
      if (res) {
        this.deviceList = res;
        if (this.selectedDepartment != "All Department") {
          let data = this.deviceList.filter(
            (val) => val.departmentName === this.selectedDepartment
          );
          this.deviceListData = [
            { deviceId: "All Machine", deviceName: "All Machine" },
            ...data,
          ];
        } else {
          this.deviceListData = [
            { deviceId: "All Machine", deviceName: "All Machine" },
            ...this.deviceList,
          ];
        }

        if (this.deviceListData.length > 0) {
          this.deviceId = this.deviceListData[0]["deviceId"];
          this.deviceName = this.deviceListData[0]["deviceName"];
          this.getData();
          this.isData = false;
        } else {
          this.isData = true;
        }
      } else {
        this.isData = true;
      }
    });
  }

  select_Department() {
    if (this.selectedDepartment != "All Department") {
      let data = this.deviceList.filter(
        (val) => val.departmentName === this.selectedDepartment
      );
      this.deviceListData = [
        { deviceId: "All Machine", deviceName: "All Machine" },
        ...data,
      ];
      let depData = this.department.find(
        (val) => val.departmentName === this.selectedDepartment
      );
      console.log(depData);
      this.selectedDepartmentId = depData["departmentId"];
    } else {
      this.deviceListData = [
        { deviceId: "All Machine", deviceName: "All Machine" },
        ...this.deviceList,
      ];
      this.selectedDepartmentId = "All Department";
    }
    if (this.deviceListData.length > 0) {
      this.deviceId = this.deviceListData[0]["deviceId"];
      this.deviceName = this.deviceListData[0]["deviceName"];
      // this.getData();
    } else {
      this.deviceId = null;
      this.deviceName = null;
      this.tableData = [];
      this.showTable = false;
      this.isData = true;
    }
  }

  onDeviceChange(selectedDeviceName: string) {
    let selectedDevice;
    if (this.selectedDepartment != "All Machine") {
      selectedDevice = this.deviceListData.find(
        (device) => device.deviceName === selectedDeviceName
      );
    } else {
      selectedDevice = this.deviceListData[0];
    }
    if (selectedDevice) {
      this.deviceId = selectedDevice.deviceId;
      this.deviceName = selectedDevice.deviceName;
      // this.getData();
    }
  }

  changeMax() {
    const today = new Date();
    today.setDate(today.getDate() - 1);
    this.maxdate = today.toISOString().split("T")[0];
  }

onFromDateChange() {
  if (this.fromDate) {
    const from = new Date(this.fromDate);
    const maxTo = new Date(from);
    maxTo.setDate(maxTo.getDate() + 30);

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    // ── Set toDate same as fromDate ──
    this.toDate = this.fromDate;

    // Use whichever is earlier: 30 days ahead OR yesterday
    this.maxdate = maxTo < yesterday
      ? maxTo.toISOString().split('T')[0]
      : yesterday.toISOString().split('T')[0];
  }
}

  getData() {
    this.cancelPreviousRequests$.next();

    const param = {
      custId: this.custId,
      deviceIds:
      this.deviceId == "All Machine" ? "All Machine" : [this.deviceId],
      fromDate: this.fromDate,
      toDate: this.toDate,
      departmentId: this.selectedDepartmentId,
      department: this.selectedDepartment,
    };

    const from = new Date(param.fromDate);
    const to = new Date(param.toDate);

    if (to < from) {
      this.tableData = [];
      this.toastr.warning("Selected Date is Invalid");
      return;
    }
    this.tableData = [];
   this.showTable = false;  // ADD THIS
      this.toastr.info("Please wait while processing", "", { disableTimeOut: true });
    this.dataservice
      .reportApi("reports/machineProduction", param).pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe(
        (res: any) => {
          this.toastr.clear();
          if (res["tabledata"]?.length) {
            this.showTable = true;
            const rawData = res["tabledata"];

            // ── Detect optional columns ──────────────────────────────────────
            this.hasBreakdown =
              rawData?.some((item) =>
                Object.prototype.hasOwnProperty.call(item, "breakdownHour")
              ) ?? false;

            this.hasInterlock =
              rawData?.some((item) =>
                Object.prototype.hasOwnProperty.call(item, "interlockHour")
              ) ?? false;

            this.hasPin2 =
              rawData?.some((item) =>
                Object.prototype.hasOwnProperty.call(item, "pin2Count")
              ) ?? false;

            this.hasAnalog1 =
              rawData?.some((item) => item.analogData?.analog1) ?? false;

            this.hasAnalog2 =
              rawData?.some((item) => item.analogData?.analog2) ?? false;

            // ── Flatten analogData into top-level properties ─────────────────
            this.tableData = rawData.map((item: any) => ({
              ...item,
              analog1Name: item.analogData?.analog1?.analogName || "",
              analog1Min: item.analogData?.analog1?.analogMin ?? 0,
              analog1Max: item.analogData?.analog1?.analogMax ?? 0,
              analog1Avg: item.analogData?.analog1?.analogAvg ?? 0,
              analog2Name: item.analogData?.analog2?.analogName || "",
              analog2Min: item.analogData?.analog2?.analogMin ?? 0,
              analog2Max: item.analogData?.analog2?.analogMax ?? 0,
              analog2Avg: item.analogData?.analog2?.analogAvg ?? 0,
            }));
          } else {
          this.toastr.clear();
            this.toastr.error("No record");
            this.showTable = false;
          }
        },
        (err) => {
          this.toastr.clear();
          this.toastr.error("No record");
          this.showTable = false;
        }
      );
  }

  openModal(templatepdf: any, data: any, act: any) {
    this.action = act;
    this.modalService.open(templatepdf, { centered: true });
  }

  get email() {
    return this.mailform.get("email");
  }

  mailexport() {
    this.pdfBool = false;
    this.csvBool = false;
    this.exportViaMail = true;
  }

  directExpo() {
    this.exportViaMail = false;
    this.pdfBool = false;
    this.csvBool = false;
    this.mailform.reset();
  }

  isEmailInvalid() {
    return this.email.invalid && (this.email.dirty || this.email.touched);
  }

  ngOnDestroy() {
        this.destroy$.next();
    this.destroy$.complete();
  }

  onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }

  pdf() {
    this.pdfBool = true;
    this.csvBool = false;
  }

  csv() {
    this.csvBool = true;
    this.pdfBool = false;
  }

  cancel() {
    this.pdfBool = false;
    this.csvBool = false;
    this.mailform.reset();
    this.exportViaMail = false;
  }

  download() {
    if (!this.pdfBool && !this.csvBool) this.pdfBool = true;

    if (this.pdfBool && this.base64String !== undefined && !this.exportViaMail) {
      const reportDate = moment(this.fromDate).format("DD-MM-YYYY");
      const pdfName = `Machine Report ${reportDate}`;
      const today = moment().format("YYYY-MM-DD HH:mm:ss");
      const year = moment().format("YYYY");

      const safeNumber = (value: any) =>
        isNaN(Number(value)) ? "0" : Number(value).toString();

      const safeTime = (value: any) =>
        value && value !== "NaN" ? value : "00:00:00";

      const formatAnalog = (name:any,min: any, max: any, avg: any) => ({
        text: [
          { text: `Name:${name}\n` },
          { text: `Min:${safeNumber(min)}\n` },
          { text: `Max:${safeNumber(max)}\n` },
          { text: `Avg:${safeNumber(avg)}\n` },
        ],
      });

      // ── PDF Header Row (dynamic columns) ──────────────────────────────────
      const headerRow: any[] = [
        { text: "Date", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Department Name", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Machine Name", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Production (hrs)", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Qty Planned", fillColor: "#007d79", bold: true, color: "#fff" },

        ...(this.hasPin2
          ? [
              { text: "Part Count 1", fillColor: "#007d79", bold: true, color: "#fff" },
              { text: "Part Count 2", fillColor: "#007d79", bold: true, color: "#fff" },
            ]
          : [{ text: "Qty Produced", fillColor: "#007d79", bold: true, color: "#fff" }]),

        { text: "Running (hrs)", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Idle (hrs)", fillColor: "#007d79", bold: true, color: "#fff" },

        ...(this.hasBreakdown
          ? [{ text: "Breakdown (hrs)", fillColor: "#007d79", bold: true, color: "#fff" }]
          : []),

        ...(this.hasInterlock
          ? [{ text: "Interlock (hrs)", fillColor: "#007d79", bold: true, color: "#fff" }]
          : []),

        { text: "Off / Power Outage (hrs)", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Downtime (hrs)", fillColor: "#007d79", bold: true, color: "#fff" },

        ...(this.hasAnalog1
          ? [{ text: "Analog-1", fillColor: "#007d79", bold: true, color: "#fff" }]
          : []),

        ...(this.hasAnalog2
          ? [{ text: "Analog-2", fillColor: "#007d79", bold: true, color: "#fff" }]
          : []),

        { text: "Availability(%)", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Performance(%)", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Quality(%)", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "OEE(%)", fillColor: "#007d79", bold: true, color: "#fff" },
        { text: "Total Energy (kWh)", fillColor: "#007d79", bold: true, color: "#fff" },
      ];

      // ── PDF Body Rows ──────────────────────────────────────────────────────
      const bodyRows = this.tableData.map((val: any) => [
        val.date?.toString() || "--",
        val.departmentName?.toString() || "--",
        val.deviceName?.toString() || "--",
        safeTime(val.productionHour),
        safeNumber(val.quantityPlanned),

        ...(this.hasPin2
          ? [
              safeNumber(val.pin1Count ? val.pin1Count : 0),
              val?.pin2Count ?? "NA",
            ]
          : [safeNumber(val.pin1Count)]),

        safeTime(val.runningHour),
        safeTime(val.idleHour),

        ...(this.hasBreakdown ? [safeTime(val.breakdownHour)] : []),
        ...(this.hasInterlock ? [safeTime(val.interlockHour)] : []),

        safeTime(val.offHour),
        safeTime(val.downTime),

        ...(this.hasAnalog1
          ? [val.analogData?.analog1 ? formatAnalog(val.analog1Name,val.analog1Min, val.analog1Max, val.analog1Avg) : "NA"]
          : []),

        ...(this.hasAnalog2
          ? [val.analogData?.analog2 ? formatAnalog(val.analog2Name,val.analog2Min, val.analog2Max, val.analog2Avg) : "NA"]
          : []),

        safeNumber(val.avaliablity),
        safeNumber(val.performance),
        safeNumber(val.quality),
        safeNumber(val.oee),
        safeNumber(val.totalEnergy),
      ]);

      const departmentSections = [
        {
          table: {
            headerRows: 1,
            widths: Array(headerRow.length).fill("auto"),
            body: [headerRow, ...bodyRows],
          },
          layout: {
            fillColor: (rowIndex: number) =>
              rowIndex === 0
                ? null
                : rowIndex % 2 === 0
                ? "#9ef0f0"
                : "#d9fbfb",
            hLineWidth: () => 0.1,
            vLineWidth: () => 0.1,
          },
          fontSize: 9,
          margin: [0, 0, 0, 10],
        },
      ];

      const pdfObject: any = {
        pageSize: "A3",
        pageOrientation: "landscape",

        header: () => ({
          text: today,
          alignment: "right",
          margin: [0, 5, 20, 0],
          fontSize: 10,
        }),

        footer: (currentPage: number, pageCount: number) => [
          {
            text: `Page ${currentPage} of ${pageCount}`,
            alignment: "center",
            fontSize: 7,
          },
          {
            text: `© ${year} Wimera Systems Pvt Ltd`,
            alignment: "right",
            fontSize: 7,
            margin: [5, 2, 10, 20],
          },
        ],

        content: [
          {
            image: this.base64String,
            width: 140,
            height: 45,
            alignment: "left",
            margin: [-30, -28, 0, 0],
          },
          {
            text: "MACHINE REPORT",
            fontSize: 15,
            bold: true,
            alignment: "center",
            margin: [0, -35, 0, 10],
          },
          {
            text: `(Duration : From ${this.fromDate} to ${this.toDate})`,
            fontSize: 10,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 10],
          },
          {
            canvas: [
              {
                type: "line",
                lineColor: "#007d79",
                x1: -40,
                y1: 0,
                x2: 2000,
                y2: 0,
                lineWidth: 0.05,
              },
            ],
            margin: [0, 0, 0, 10],
          },
          {
            text: `Customer Name: ${this.custName}`,
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 5],
          },
          ...departmentSections,
        ],
      };

      pdfMake.createPdf(pdfObject).download(`${pdfName}.pdf`);
    } else if (this.csvBool && !this.exportViaMail) {
      const formatAnalogCSV = (name:any, min: any, max: any, avg: any) => {
        const safe = (val: any) =>
          val != null && !isNaN(Number(val)) ? Number(val) : 0;
        return `"Name: ${name} Min:${safe(min)} Max:${safe(max)} Avg:${safe(avg)}"`;
      };

      const masterData = this.tableData;
      const startDate = moment(this.fromDate).format("YYYY-MM-DD");
      const endDate = moment(this.toDate).format("YYYY-MM-DD");
      let csvContent = "";
      csvContent += "MACHINE REPORT\n";
      csvContent += `Date: ${startDate + " to " + endDate}\n\n`;

      // ── CSV Header ─────────────────────────────────────────────────────────
      csvContent +=
        [
          "Date",
          "Department Name",
          "Machine Name",
          "Production (hrs)",
          "QtyPlanned",
          ...(this.hasPin2 ? ["Part Count 1", "Part Count 2"] : ["Qty Produced"]),
          "Running (hrs)",
          "Idle (hrs)",
          ...(this.hasBreakdown ? ["Breakdown (hrs)"] : []),
          ...(this.hasInterlock ? ["Interlock (hrs)"] : []),
          "Off / Power Outage (hrs)",
          "Downtime (hrs)",
          ...(this.hasAnalog1 ? ["Analog-1"] : []),
          ...(this.hasAnalog2 ? ["Analog-2"] : []),
          "Availability(%)",
          "Performance(%)",
          "Quality(%)",
          "Oee(%)",
          "Total Energy (kWh)",
        ].join(",") + "\n";

      // ── CSV Rows ───────────────────────────────────────────────────────────
      masterData.forEach((machine) => {
        csvContent +=
          [
            machine.date?.toString() || "--",
            machine.departmentName || "N/A",
            machine.deviceName || "N/A",
            machine.productionHour || "00:00:00",
            machine.quantityPlanned != null ? machine.quantityPlanned : "0",
            ...(this.hasPin2
              ? [machine?.pin1Count ?? 0, machine?.pin2Count ?? "NA"]
              : [machine?.pin1Count ?? 0]),
            machine.runningHour || "00:00:00",
            machine.idleHour || "00:00:00",
            ...(this.hasBreakdown ? [machine?.breakdownHour ?? "00:00:00"] : []),
            ...(this.hasInterlock ? [machine?.interlockHour ?? "00:00:00"] : []),
            machine.offHour || "00:00:00",
            machine.downTime || "00:00:00",
            ...(this.hasAnalog1
              ? [machine.analogData?.analog1 ? formatAnalogCSV(machine.analog1Name,machine.analog1Min, machine.analog1Max, machine.analog1Avg) : "NA"]
              : []),
            ...(this.hasAnalog2
              ? [machine.analogData?.analog2 ? formatAnalogCSV(machine.analog2Name,machine.analog2Min, machine.analog2Max, machine.analog2Avg) : "NA"]
              : []),
            machine.avaliablity || 0,
            machine.performance || 0,
            machine.quality || 0,
            machine.oee || 0,
            machine.totalEnergy || 0,
          ].join(",") + "\n";
      });

      const encodedUri =
        "data:text/csv;charset=utf-8," + encodeURIComponent(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `Machine Report ${startDate}.csv`);
      document.body.appendChild(link);
      link.click();
    } else if (this.pdfBool && this.exportViaMail) {
      let data = this.mailform.value;
      let maildata = {};
      (maildata["to"] = data["email"]),
        (maildata["departmentData"] = this.tableData),
        (maildata["machineName"] = this.deviceName),
        (maildata["departmentName"] = this.selectedDepartment),
        (maildata["reportname"] = "MachineReports"),
        (maildata["fromDate"] = this.fromDate),
        (maildata["toDate"] = this.toDate),
        (maildata["customerName"] = this.custName),
        (maildata["filetype"] = "pdf");
      this.toastr.info("Please wait while processing");
      this.dataservice.post("api/sendMail", maildata).subscribe(
        (res) => {
          this.toastr.success("Mail sent successfully!");
        },
        (err) => {
          this.toastr.error(err.message);
        }
      );
    } else if (this.csvBool && this.exportViaMail) {
      let data = this.mailform.value;
      let maildata = {};
      (maildata["to"] = data["email"]),
        (maildata["departmentData"] = this.tableData),
        (maildata["machineName"] = this.deviceName),
        (maildata["departmentName"] = this.selectedDepartment),
        (maildata["reportname"] = "MachineReports"),
        (maildata["fromDate"] = this.fromDate),
        (maildata["toDate"] = this.toDate),
        (maildata["customerName"] = this.custName),
        (maildata["filetype"] = "csv");
      this.toastr.info("please wait while processing");
      this.dataservice.post("api/sendMail", maildata).subscribe(
        (res) => {
          this.toastr.success("Mail sent successfully!");
        },
        (err) => {
          this.toastr.error(err.message);
        }
      );
    }

    this.pdfBool = false;
    this.csvBool = false;
    this.exportViaMail = false;
    this.mailform.reset();
  }
}